module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight tabBox",
    attrs: {
      "id": "driveAlarmTired"
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alarm_process_icon"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.stepOneActive, 'finish': !_vm.stepOneActive && _vm.stepOneStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jibenxinxi"
  }), _c('span', [_vm._v("基本信息")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepTwoActive, 'finish': !_vm.stepTwoActive && _vm.stepTwoStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-baojingfangshi"
  }), _c('span', [_vm._v("报警方式")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepThreeActive, 'finish': !_vm.stepThreeActive && _vm.stepThreeStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongquyu"
  }), _c('span', [_vm._v("报警阈值")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFourActive, 'finish': !_vm.stepFourActive && _vm.stepFourStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongshiduan"
  }), _c('span', [_vm._v("监控时段")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFiveActive, 'finish': !_vm.stepFiveActive && _vm.stepFiveStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongcheliang"
  }), _c('span', [_vm._v("监控车辆")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepSixActive
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng"
  }), _c('span', [_vm._v("完成")])])])])])]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepOneActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanBase', {
    attrs: {
      "imageData": _vm.imgdata,
      "title": "疲劳驾驶报警",
      "systemAlarms": "当驾驶人连续驾驶车辆超出约定时限时，触发系统报警。",
      "bgClass": "alarm_list_bg05"
    },
    model: {
      value: (_vm.alarmBaseInfo),
      callback: function($$v) {
        _vm.alarmBaseInfo = $$v
      },
      expression: "alarmBaseInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepTwoActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMode', {
    attrs: {
      "parentid": _vm.pageid
    },
    model: {
      value: (_vm.alarmModeInfo),
      callback: function($$v) {
        _vm.alarmModeInfo = $$v
      },
      expression: "alarmModeInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepThreeActive ? 'block' : 'none'
    })
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-inline grey_box ofh pt10px",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "focus_color mr30px"
  }, [_vm._v("报警方式")]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.alarmThreshold.gpsEstimate),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "gpsEstimate", $$v)
      },
      expression: "alarmThreshold.gpsEstimate"
    }
  }, [_vm._v("基于GPS判断")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "0"
    },
    model: {
      value: (_vm.alarmThreshold.gpsEstimate),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "gpsEstimate", $$v)
      },
      expression: "alarmThreshold.gpsEstimate"
    }
  }, [_vm._v("基于定位设备硬件判")])], 1)]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_vm._v("(需定位设备硬件设备支持)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "form-group pt5px"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_vm._v("连续驾驶车辆行驶")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input-number', {
    attrs: {
      "min": 1,
      "max": 24,
      "controls": false,
      "inputWidth": 160
    },
    model: {
      value: (_vm.alarmThreshold.hours),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "hours", $$v)
      },
      expression: "alarmThreshold.hours"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("小时以上，且中途停车休息时间累计不足")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input-number', {
    attrs: {
      "min": 0,
      "max": 1440,
      "controls": false,
      "inputWidth": 160
    },
    model: {
      value: (_vm.alarmThreshold.minute),
      callback: function($$v) {
        _vm.$set(_vm.alarmThreshold, "minute", $$v)
      },
      expression: "alarmThreshold.minute"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_vm._v("分钟的，发送疲劳驾驶报警。")])])])])]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFourActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanPeriod', {
    attrs: {
      "parentid": _vm.pageid
    },
    model: {
      value: (_vm.alarmPeriodInfo),
      callback: function($$v) {
        _vm.alarmPeriodInfo = $$v
      },
      expression: "alarmPeriodInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFiveActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMonitor', {
    attrs: {
      "typeid": _vm.typeid
    },
    model: {
      value: (_vm.alarmMonitorInfo),
      callback: function($$v) {
        _vm.alarmMonitorInfo = $$v
      },
      expression: "alarmMonitorInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepSixActive ? 'block' : 'none'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center pt10px"
  }, [(_vm.preBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.nextBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.finishBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("完成")]) : _vm._e()])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 "
  }, [_c('div', {
    staticClass: "module_title"
  }, [_c('span', {
    staticClass: "focus_color"
  }, [_vm._v("请设置报警阈值")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557e793c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclealarm/drivealarm/PageDriveAlarmTired.vue
// module id = 1522
// module chunks = 0